import * as RadixTooltip from '@radix-ui/react-tooltip'
import React from 'react';

interface TooltipProps {
  children: React.ReactNode;
  content: string;
  open?: boolean;
  arrowPlacement?: 'start' | 'center' | 'end'; // 新增支持箭头位置
  side?: 'top' | 'right' | 'bottom' | 'left'; // 可以调整弹窗显示方向
  sideOffset?: number; // 控制弹窗偏移
  arrowOffset?: number; // 控制箭头偏移
}

const tooltipContentStyle: React.CSSProperties = {
  zIndex: 10000,
  userSelect: 'none',
  borderRadius: '12px',
  maxWidth: '270px',
  background: '#EDFDFF',
  padding: '9px 16px',
  fontSize: '16px',
  fontWeight: 400,
  color: '#229CC9',
  fontFamily: 'helvetica, arial, sans-serif',
  boxShadow:
    '0px 10px 38px -10px hsl(206,22%,7%,0.35), 0px 10px 20px -15px hsl(206,22%,7%,0.2)',
  willChange: 'transform, opacity',
};

const arrowStyle: React.CSSProperties = {
  fill: '#EDFDFF',
};

const getAlign = (arrowPlacement?: 'start' | 'center' | 'end') => {
  if (arrowPlacement === 'start') return 'start';
  if (arrowPlacement === 'end') return 'end';
  return 'center';
};

const Tooltip = ({
  children,
  content,
  open = undefined,
  arrowPlacement = 'center',
  side = 'top',
  sideOffset = 5,
  arrowOffset = 0,
}: TooltipProps) => {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root delayDuration={0} open={open}>
        <RadixTooltip.Trigger asChild>
          {children}
        </RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={side}
            align={getAlign(arrowPlacement)}
            sideOffset={sideOffset}
            style={tooltipContentStyle}
          >
            {content}
            <RadixTooltip.Arrow
              style={{
                ...arrowStyle,
                // 可以用 offset 值来左右或上下偏移箭头
                [side === 'top' || side === 'bottom'
                  ? 'marginLeft'
                  : 'marginTop']: arrowOffset,
              }}
            />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};

export default Tooltip;
